











import { Component, Watch, Vue } from 'vue-property-decorator'
import { State, Getter, namespace } from 'vuex-class'
import SurfaceHeader from 'vuecomponents/surface_header.vue'
import SurfaceSections from 'vuecomponents/surface_sections.vue'
import PasteToPostMixin from 'vuemixins/paste_to_post_mixin'
import DropToPostMixin from 'vuemixins/drop_to_post_mixin'
import { scrollToSection } from 'surface/scroll_to_new_post'

const post = namespace('post')
const section = namespace('section')

@Component({
  components: {
    SurfaceHeader,
    SurfaceSections,
  },
  mixins: [PasteToPostMixin, DropToPostMixin],
})
export default class SurfaceContainerShelf extends Vue {
  @State xHeader
  @post.Getter newestPostCid
  @post.Getter postEntitiesByCid
  @section.Action startEditingSection
  @section.Action deleteSection
  @Getter isPostable

  enablePasteToPost!: () => void // from PasteToPostMixin
  disablePasteToPost!: () => void // from PasteToPostMixin
  enableDropToPost!: (wallContainer: Element) => void // from DropToPostMixin
  disableDropToPost!: (wallContainer: Element) => void // from DropToPostMixin

  mounted() {
    this.$nextTick(() => this.toggleNewPostHandlers(this.isPostable))
  }

  beforeDestroy() {
    this.disableNewPostHandlers()
  }

  enableNewPostHandlers() {
    this.enablePasteToPost()
    this.enableDropToPost(this.$el)
  }

  disableNewPostHandlers() {
    this.disablePasteToPost()
    this.disableDropToPost(this.$el)
  }

  @Watch('isPostable')
  toggleNewPostHandlers(newValue) {
    newValue ? this.enableNewPostHandlers() : this.disableNewPostHandlers()
  }

  @Watch('newestPostCid')
  scrollWallToSection(postCid) {
    const sectionElement = document.getElementById(`section-${this.postEntitiesByCid[postCid].wall_section_id}`)
    scrollToSection(this.$refs.wishList, sectionElement)
  }
}
